import { useCurrentUser } from '@ianesthesie-kit/redux';
import { User } from '@ianesthesie-kit/services';
import { isSecretary } from '@/modules/doctorBff.model';

export const isUserRestricted = (user: User | null) =>
  !!user && isSecretary(user);

export const useIsUserRestricted = () => isUserRestricted(useCurrentUser());
